import { combineUrl } from '../utils/utils';
import { HttpStatusCodeError } from '../errors/http-status-code-error';
export class ApplicationInsightsHttpClient {
    constructor(baseUrl, logger) {
        this.baseUrl = baseUrl;
        this.logger = logger;
    }
    async post(url, body) {
        const requestOptions = {
            method: 'POST',
            body: body ? JSON.stringify(body) : null,
            headers: new Headers()
        };
        await this.send(url, requestOptions);
    }
    async send(relativeUri, requestOptions) {
        var _a;
        let response;
        let lastError;
        let tries = 0;
        for (const retryInterval of ApplicationInsightsHttpClient.retryIntervals) {
            response = null;
            try {
                tries++;
                response = await fetch(combineUrl(this.baseUrl, relativeUri), requestOptions);
                // retry if neccessary
                if (tries < ApplicationInsightsHttpClient.retryIntervals.length && ApplicationInsightsHttpClient.shouldRetry(response)) {
                    this.logger.logWarning(`ApplicationInsights HTTP: Request failed with response status code '${response.status}'.`);
                    this.logger.logInformation(`ApplicationInsights HTTP: Retrying in '${retryInterval}' milliseconds...`);
                    await ApplicationInsightsHttpClient.delay(retryInterval);
                    continue;
                }
            }
            catch (error) {
                lastError = error;
                if (tries < ApplicationInsightsHttpClient.retryIntervals.length) {
                    this.logger.logWarning(`ApplicationInsights HTTP: ${(_a = error) !== null && _a !== void 0 ? _a : 'Request failed with error.'}`);
                    this.logger.logInformation(`ApplicationInsights HTTP: Retrying in '${retryInterval}' milliseconds...`);
                    await ApplicationInsightsHttpClient.delay(retryInterval);
                    continue;
                }
            }
            if (response) {
                if (response.status >= 400) {
                    throw new HttpStatusCodeError(response.status, response.statusText);
                }
                return;
            }
        }
        this.logger.logInformation('ApplicationInsights HTTP: All retries have failed.');
        this.logger.logError(`ApplicationInsights HTTP: ${lastError}`);
        throw lastError;
    }
    static delay(milliseconds) {
        return new Promise((resolve) => {
            setTimeout(() => resolve(), milliseconds);
        });
    }
    static shouldRetry(response) {
        return response.status === 0 || response.status === 408 || response.status === 429 || response.status === 500 || response.status === 503;
    }
}
ApplicationInsightsHttpClient.retryIntervals = [0, 1000, 3000, 5000, 25000];
